import { FC } from 'react';
import styled from 'styled-components';
import { isProductInList } from './sortingHelper';
import ProductItemWrapper from './ProductItemWrapper';
import { ProductOut } from '../../../../store/api';

const paginationPaddingProductListBottomToFooterInPx = '100px';
const StProductList = styled.div`
    padding-bottom: ${paginationPaddingProductListBottomToFooterInPx};
    padding-top: 30px;
    padding-left: 30px;
`;

interface Props {
    productList: ProductOut[];
    checkedProducts: ProductOut[];
    handleStatefulMove: (indexInList: number) => void;
    handleStatelessMove: (currentProductRank: number, nextProductRank: number) => void;
    handleProductSelection: (product: ProductOut) => void;
}

export const ProductList: FC<Props> = ({
    productList,
    checkedProducts,
    handleStatefulMove,
    handleStatelessMove,
    handleProductSelection
}) => {
    const inSelectionMode = checkedProducts.length > 0;

    return (
        <StProductList>
            {productList.map((product, index) => {
                const isProductChecked = isProductInList(product, checkedProducts);

                return (
                    <ProductItemWrapper
                        key={product.id}
                        product={product}
                        handleProductSelection={() => handleProductSelection(product)}
                        isProductChecked={isProductChecked}
                        isInSelectionMode={inSelectionMode}
                        index={index}
                        handleStatefulMove={handleStatefulMove}
                        handleStatelessMove={handleStatelessMove}
                    />
                );
            })}
        </StProductList>
    );
};
